import { createFileRoute, lazyRouteComponent } from '@tanstack/react-router';

export const Route = createFileRoute(
  '/_authenticated/_dashboard/accounts/$accountId/serverless-spaces/$spaceId/_tabs/collections/$collectionName/info',
)({
  component: lazyRouteComponent(
    () => import('@/components/Serverless/SpaceCollections/SpaceCollectionInfo'),
    'SpaceCollectionInfo',
  ),
});
